import { useEvent, useState } from 'hooks'
import { exportPptx } from 'services'

import { getPptxExportSelector } from './selector'

type State = {
	pptxExports?: NodeListOf<HTMLElement>
}

const INIT_ATTR = 'data-pptx-init'

export const PptxExport = (() => {
	const { state, setState } = useState<State>()

	const init = () => {
		setState({
			pptxExports: getPptxExportSelector(),
		})

		const { pptxExports } = state
		if (!pptxExports) {
			return
		}

		for (let i = 0; i < pptxExports.length; i++) {
			const exportButton = pptxExports[i]

			if (!exportButton || exportButton.hasAttribute(INIT_ATTR)) {
				continue
			}

			exportButton.setAttribute(INIT_ATTR, '1')

			const click = useEvent(exportButton, 'click')
			click.register(() => {
				exportPptx()
			})
		}
	}

	return {
		init,
	}
})()
